"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
var _OrderDetail = _interopRequireDefault(require("./components/OrderDetail.vue"));
var _RefundDialog = _interopRequireDefault(require("../components/RefundDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderList',
  components: {
    OrderDetail: _OrderDetail.default,
    RefundDialog: _RefundDialog.default
  },
  data: function data() {
    return {
      // 搜索表单数据
      pageFrom: {
        page: 1,
        limit: 20,
        orderNo: '',
        outTradeNo: '',
        storeId: '',
        orderStatus: '',
        orderCategory: '',
        orderType: 1
      },
      // 表格数据
      tableData: {
        list: [],
        total: 0
      },
      loading: false,
      // 店铺选项
      storeOptions: [],
      // 订单类型：1外卖订单 2自提订单
      orderCategoryOptions: [{
        value: 1,
        label: '外卖'
      }, {
        value: 2,
        label: '自提'
      }],
      // 订单状态选项
      orderStatusOptions: [{
        value: '',
        label: '全部'
      }, {
        value: 1,
        label: '待支付'
      }, {
        value: 2,
        label: '待接单'
      }, {
        value: 3,
        label: '备货中'
      }, {
        value: 4,
        label: '待自提'
      }, {
        value: 5,
        label: '配送中'
      }, {
        value: 6,
        label: '已取消'
      }, {
        value: 7,
        label: '已退款'
      }, {
        value: 8,
        label: '已完结'
      }, {
        value: 14,
        label: '部分退款'
      }],
      // 异步下载相关
      downloadTaskId: null,
      downloadProgress: 0,
      downloadStatus: '',
      downloadTimer: null,
      isDownloading: false
    };
  },
  mounted: function mounted() {
    this.getList();
    // 获取店铺列表
    this.getStoreOptions();
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁时清理定时器
    this.stopPolling();
  },
  methods: {
    // 获取列表数据
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _rsManagement.getOrderList)(this.pageFrom);
            case 2:
              res = _context.v;
              if (res) {
                this.tableData.list = res.list || [];
                this.tableData.total = res.total || 0;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取订单列表失败：', _t);
              this.$message.error('获取数据失败：' + (_t.message || '未知错误'));
              this.tableData.list = [];
              this.tableData.total = 0;
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 获取店铺选项
    getStoreOptions: function () {
      var _getStoreOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _rsManagement.getStoreList)({
                page: 1,
                limit: 1000
              });
            case 1:
              res = _context2.v;
              if (res && res.list) {
                this.storeOptions = res.list.map(function (item) {
                  return {
                    value: item.id,
                    label: item.storeName
                  };
                });
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('获取店铺列表失败：', _t2);
              // 如果获取失败，使用空数组
              this.storeOptions = [];
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getStoreOptions() {
        return _getStoreOptions.apply(this, arguments);
      }
      return getStoreOptions;
    }(),
    // 搜索
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.pageFrom = {
        page: 1,
        limit: 20,
        orderNo: '',
        outTradeNo: '',
        storeId: '',
        orderStatus: '',
        orderCategory: '',
        orderType: 1
      };
      this.getList();
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageFrom.limit = val;
      this.getList();
    },
    // 页码改变
    pageChange: function pageChange(val) {
      this.pageFrom.page = val;
      this.getList();
    },
    // 异步导出订单
    exportOrders: function () {
      var _exportOrders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!this.isDownloading) {
                _context3.n = 1;
                break;
              }
              this.$message.warning('正在导出中，请稍候...');
              return _context3.a(2);
            case 1:
              _context3.p = 1;
              this.isDownloading = true;
              this.downloadProgress = 0;
              this.downloadStatus = '创建任务中...';

              // 创建异步下载任务
              _context3.n = 2;
              return (0, _rsManagement.createAsyncOrderExportTask)(this.pageFrom);
            case 2:
              res = _context3.v;
              if (!(res && res.taskId)) {
                _context3.n = 3;
                break;
              }
              this.downloadTaskId = res.taskId;
              this.downloadStatus = '任务创建成功，开始处理...';
              this.$message.success('导出任务创建成功，正在处理中...');

              // 开始轮询任务状态
              this.startPollingTaskStatus();
              _context3.n = 4;
              break;
            case 3:
              throw new Error('创建任务失败');
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t3 = _context3.v;
              console.error('创建导出任务失败：', _t3);
              this.$message.error('创建导出任务失败：' + (_t3.message || '未知错误'));
              this.isDownloading = false;
              this.downloadStatus = '';
              this.downloadProgress = 0;
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 5]]);
      }));
      function exportOrders() {
        return _exportOrders.apply(this, arguments);
      }
      return exportOrders;
    }(),
    // 开始轮询任务状态
    startPollingTaskStatus: function startPollingTaskStatus() {
      var _this = this;
      if (this.downloadTimer) {
        clearInterval(this.downloadTimer);
      }
      this.downloadTimer = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _rsManagement.getDownloadTaskStatus)(_this.downloadTaskId);
            case 1:
              res = _context4.v;
              if (res) {
                _this.downloadProgress = res.progress || 0;
                _this.downloadStatus = _this.getStatusText(res.status);
                if (res.status === 'COMPLETED') {
                  // 任务完成，直接使用filePath进行下载
                  if (res.filePath) {
                    _this.downloadFileByFilePath(res.filePath, res.fileName);
                  } else if (res.downloadUrl) {
                    _this.downloadFileByUrl(res.downloadUrl, res.fileName);
                  } else {
                    // 如果既没有filePath也没有downloadUrl，提示错误
                    _this.$message.error('导出完成但无法获取下载地址，请重新导出');
                    console.error('任务完成但缺少文件路径信息：', res);
                  }
                  _this.stopPolling();
                } else if (res.status === 'FAILED') {
                  // 任务失败
                  _this.$message.error('导出失败：' + (res.errorMessage || '未知错误'));
                  _this.stopPolling();
                }
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.error('查询任务状态失败：', _t4);
              _this.$message.error('查询任务状态失败');
              _this.stopPolling();
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 2]]);
      })), 2000); // 每2秒查询一次
    },
    // 停止轮询
    stopPolling: function stopPolling() {
      if (this.downloadTimer) {
        clearInterval(this.downloadTimer);
        this.downloadTimer = null;
      }
      this.isDownloading = false;
      this.downloadStatus = '';
      this.downloadProgress = 0;
      this.downloadTaskId = null;
    },
    // 使用filePath下载文件
    downloadFileByFilePath: function () {
      var _downloadFileByFilePath = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(filePath, fileName) {
        var downloadUrl, httpsIndex, link;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              try {
                // 从filePath中提取HTTPS URL部分
                downloadUrl = filePath; // 如果filePath包含https，则从https开始截取到最后
                httpsIndex = filePath.indexOf('https://');
                if (httpsIndex !== -1) {
                  downloadUrl = filePath.substring(httpsIndex);
                }
                console.log('原始filePath:', filePath);
                console.log('处理后的downloadUrl:', downloadUrl);

                // 创建隐藏的下载链接
                link = document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName;
                link.target = '_blank';
                link.style.display = 'none';

                // 添加到DOM并触发点击
                document.body.appendChild(link);
                link.click();

                // 清理DOM
                document.body.removeChild(link);
                this.$message.success('文件下载成功');
              } catch (error) {
                console.error('下载文件失败：', error);
                this.$message.error('下载文件失败：' + (error.message || '未知错误'));
              }
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function downloadFileByFilePath(_x, _x2) {
        return _downloadFileByFilePath.apply(this, arguments);
      }
      return downloadFileByFilePath;
    }(),
    // 使用完整URL下载文件
    downloadFileByUrl: function () {
      var _downloadFileByUrl = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(downloadUrl, fileName) {
        var link;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              try {
                // 创建隐藏的下载链接
                link = document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName;
                link.target = '_blank';
                link.style.display = 'none';

                // 添加到DOM并触发点击
                document.body.appendChild(link);
                link.click();

                // 清理DOM
                document.body.removeChild(link);
                this.$message.success('文件下载成功');
              } catch (error) {
                console.error('下载文件失败：', error);
                this.$message.error('下载文件失败：' + (error.message || '未知错误'));
              }
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function downloadFileByUrl(_x3, _x4) {
        return _downloadFileByUrl.apply(this, arguments);
      }
      return downloadFileByUrl;
    }(),
    // 下载文件（兼容旧版本）
    downloadFile: function () {
      var _downloadFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(fileName) {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              try {
                // 如果只有文件名，无法直接下载，提示用户
                this.$message.error('无法获取文件下载地址，请重新导出');
                console.error('缺少文件路径信息，无法下载文件：', fileName);
              } catch (error) {
                console.error('下载文件失败：', error);
                this.$message.error('下载文件失败：' + (error.message || '未知错误'));
              }
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function downloadFile(_x5) {
        return _downloadFile.apply(this, arguments);
      }
      return downloadFile;
    }(),
    // 获取状态文本
    getStatusText: function getStatusText(status) {
      var statusMap = {
        'PENDING': '等待处理',
        'PROCESSING': '处理中',
        'COMPLETED': '处理完成',
        'FAILED': '处理失败'
      };
      return statusMap[status] || '未知状态';
    },
    // 查看订单
    viewOrder: function viewOrder(row) {
      this.$refs.orderDetailRef.open(row.orderNo);
    },
    // 打印小票
    printTicket: function () {
      var _printTicket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(row) {
        var printData, _t5;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              printData = {
                // printerSn: row.printerSn || '521650237', // 打印机序列号，如果订单数据中没有则使用空字符串
                orderId: row.id,
                // 订单ID
                times: 1 // 默认打印1份
              };
              _context8.n = 1;
              return (0, _rsManagement.printOrderTicket)(printData);
            case 1:
              this.$message.success('小票打印成功');
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t5 = _context8.v;
              console.error('打印小票失败：', _t5);
              this.$message.error('打印失败：' + (_t5.message || '未知错误'));
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function printTicket(_x6) {
        return _printTicket.apply(this, arguments);
      }
      return printTicket;
    }(),
    // 接单
    _acceptOrder: function () {
      var _acceptOrder2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(row) {
        var _t6;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              _context9.n = 1;
              return (0, _rsManagement.acceptOrder)(row.orderNo);
            case 1:
              this.$message.success('接单成功');
              // 刷新列表
              this.getList();
              _context9.n = 3;
              break;
            case 2:
              _context9.p = 2;
              _t6 = _context9.v;
              console.error('接单失败：', _t6);
              this.$message.error('接单失败：' + (_t6.message || '未知错误'));
            case 3:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function _acceptOrder(_x7) {
        return _acceptOrder2.apply(this, arguments);
      }
      return _acceptOrder;
    }(),
    // 退款
    openRefund: function openRefund(row) {
      this.$refs.refundDialogRef.open(row);
    },
    isCanRefund: function isCanRefund(row) {
      return row.canRefund === true || Number(row.canRefund) === 1;
    },
    showDeliverButton: function showDeliverButton(row) {
      var status = Number(row.status);
      return Number(row.autoDelivery) === 2 && [3, 4, 11].includes(status);
    },
    handleDeliver: function handleDeliver(row) {
      var _this2 = this;
      this.$confirm('是否确认发货？', '发货确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _t7;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              _context0.p = 0;
              _context0.n = 1;
              return (0, _rsManagement.deliverOrder)(row.orderNo);
            case 1:
              _this2.$message.success('发货成功');
              _this2.getList();
              _context0.n = 3;
              break;
            case 2:
              _context0.p = 2;
              _t7 = _context0.v;
              console.error('发货失败：', _t7);
              _this2.$message.error('发货失败：' + (_t7.message || '未知错误'));
            case 3:
              return _context0.a(2);
          }
        }, _callee0, null, [[0, 2]]);
      }))).catch(function () {});
    },
    // 获取订单状态类型
    getOrderStatusType: function getOrderStatusType(status) {
      var statusMap = {
        '1': 'warning',
        // 待支付 - 橙色表示等待状态
        '2': 'primary',
        // 待接单 - 蓝色表示等待接单状态
        '3': 'primary',
        // 备货中 - 蓝色表示处理中状态
        '4': 'info',
        // 待自提 - 灰色表示等待自提状态
        '5': 'primary',
        // 配送中 - 蓝色表示配送中状态
        '6': 'danger',
        // 已取消 - 红色表示取消状态
        '7': 'warning',
        // 已退款 - 橙色表示退款状态
        '8': 'success',
        // 已完结 - 绿色表示完成状态
        '14': 'warning' // 部分退款
      };
      return statusMap[status] || 'info';
    },
    // 获取订单状态文本
    getOrderStatusText: function getOrderStatusText(status) {
      var statusMap = {
        '1': '待支付',
        '2': '待接单',
        '3': '备货中',
        '4': '待自提',
        '5': '配送中',
        '6': '已取消',
        '7': '已退款',
        '8': '已完结',
        '14': '部分退款'
      };
      return statusMap[status] || '未知状态';
    },
    // 获取物流状态类型
    getLogisticsStatusType: function getLogisticsStatusType(status) {
      var statusMap = {
        '0': 'info',
        // 未发货
        '1': 'primary',
        // 已发货
        '2': 'success' // 签收
      };
      return statusMap[status] || 'info';
    },
    // 获取物流状态文本
    getLogisticsStatusText: function getLogisticsStatusText(status) {
      var statusMap = {
        '0': '未发货',
        '1': '已发货',
        '2': '签收'
      };
      return statusMap[status] || '未知状态';
    }
  }
};